import React, { useMemo } from 'react';
import { OverviewListTable } from '@icoach/components';
import { isFunction } from "@util/utils";
import useOrderBatchPaymentApi from '@apis/useOrderBatchPaymentApi';
import useExportActionDialog from '@util/hook/useExportActionDialog';
import useMessageDialog from '@util/hook/useMessageDialog';
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";
import { getBillingRowsLabel } from "@icoach/batchPayment/component/BillingRowsLabelTemplate";

const DebitListForBilling = ({ list, ...rest }) => {
    const { dialogRef, searchParams, getBatchPayments } = useBatchPaymentContext();
    const { deleteOrderBatchPaymentBillingApi, postOrderBatchPaymentAchExportApi } = useOrderBatchPaymentApi();
    const { showExportConfirmDialog } = useExportActionDialog({ checkExportPermission: false });
    const setMessageDialog = useMessageDialog();

    const doDeleteOrderBatchPaymentBillingApi = async (billingID, onClose) => {
        let res = await deleteOrderBatchPaymentBillingApi(billingID);
        if (res) {
            isFunction(getBatchPayments) && getBatchPayments(searchParams);
            onClose();
        }
    };

    // 下載扣款名單
    const handleClickDownloadACH = (billingID) => {
        showExportConfirmDialog({}, (params) => {
            postOrderBatchPaymentAchExportApi(billingID, params);
        });
    };

    // 刪除扣款群組
    const handleDeleteBilling = (billingID) => {
        setMessageDialog({
            open: true,
            title: '確認取消批次扣款',
            msg: '取消後將停止交易作業且無法恢復，請問確定要取消嗎?',
            onAsyncConfirm: (_, onClose) => doDeleteOrderBatchPaymentBillingApi(billingID, onClose),
        });
    };

    const headerRow = useMemo(
        () => {
            return getBillingRowsLabel();
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <OverviewListTable
            list={list || []}
            headerRow={headerRow}
            tableRowBodyProps={{ dialogRef, refresh: getBatchPayments, onClickDownloadACH: handleClickDownloadACH, onDeleteBilling: handleDeleteBilling }}
            isGray
            {...rest}
        />
    );
};

export default DebitListForBilling;
